import { getGlobalSelector } from './mmd';

const getRoot = () => getGlobalSelector().additionalSelectors.leadFormInfoSelectors;
export const isOfferSubmitSuccess = (state: any) => getRoot().isOfferSubmitSuccess(state);
export const isOfferSubmitFailed = (state: any) => getRoot().isOfferSubmitFailed(state);
